/**
 * LiveScanHudActions (2026-09-29 owner ask): the Android HUD card carries
 * three buttons, star / trade / open, and the bubble opens the Live Scan
 * sheet when tapped while Nexus Dex is in front. This mounts once in
 * App.tsx and turns those native taps into app actions.
 */
import { useEffect } from "react";
import { useLocation } from "wouter";
import { openDexLiveScanMenu } from "@/lib/dexLiveScanMenuState";
import { getMyPokemon, setRecordFavourite } from "@/lib/myPokemonStore";
import { subscribePipActions } from "@/lib/nexPip";
import { toggleTradeList } from "@/lib/tradeListStore";

export function LiveScanHudActions() {
  const [, setLocation] = useLocation();
  useEffect(() => {
    return subscribePipActions((a) => {
      const id = a.recordId ?? "";
      // One tap is one action since nexPip3D's listener registration became
      // single-flight (2026-09-30): a Star used to arrive twice and toggle
      // the record on and straight off.
      // eslint-disable-next-line no-console
      console.log("[live-scan] hud action", {
        action: a.action,
        recordId: id || null,
        favouriteBefore: id ? !!getMyPokemon(id)?.isFavourite : null,
      });
      switch (a.action) {
        case "menu":
          openDexLiveScanMenu();
          break;
        case "favourite":
          if (id) setRecordFavourite(id, !getMyPokemon(id)?.isFavourite);
          break;
        case "trade":
          if (id) toggleTradeList(id);
          break;
        case "open":
          // The native side brings the app to the front; this lands it on
          // the record.
          if (id) setLocation(`/my-pokemon/${id}`);
          break;
      }
    });
  }, [setLocation]);
  return null;
}
